<template>
  <section class="cp-page-out">
    <section class="cp-error">
      <img src="./images/404_bg.png" class="icon" />
      <p class="text">{{ text }}</p>
      <p @click="$emit('refresh')" class="btn">立即刷新</p>
    </section>
  </section>
</template>

<script>
export default {
  name: 'cpPageOut',
  components: {},
  props: {
    text: {
      type: String,
      default: '网络开小差了，刷新试试'
    },
  },
  data () {
    return {}
  },
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.cp-page-out {
  height:100%;
  width: 100%;
}
.cp-error{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  height: 100%;
  img {
    width: 80%;
    height: 30%;
  }
  .text {
    margin: 0 0 15px;
    font-size: 18px;
    color: $main-color;
    font-weight: 500;
    width: 85%;
  }
  .btn {
    padding: 10px 14px;
    font-size: 18px;
    color: #fff;
    text-align: center;
    border-radius: 0.04px;
    background-color: $main-color;
  }
}
</style>
